import { MAPBOX_STYLES, MapGL } from '@cibo/mapgl'
import { useTheme } from '@mui/material'
import { FullscreenControl } from 'react-map-gl/dist/es5'
import { EnrolledFieldsLayer } from '../../../../components/EnrolledFieldsLayer'

export const ProgramEnrollmentMap = () => {
  const {
    palette: { mode },
  } = useTheme()
  return (
    <MapGL mapStyle={MAPBOX_STYLES.FOCUSED[mode]}>
      <EnrolledFieldsLayer />
      <FullscreenControl />
    </MapGL>
  )
}
